/**
 * CPT audit snapshot persisted on Standard Delivery options at quote time.
 * Mirrors garaaz-backend/src/modules/estimate/ready-time/cpt-audit.types.ts
 */

export enum MovementKind {
  SAME_SUPPLIER = "SAME_SUPPLIER",
  WAREHOUSE_TO_OUTLET = "WAREHOUSE_TO_OUTLET",
  OUTLET_TO_WAREHOUSE = "OUTLET_TO_WAREHOUSE",
  SAME_ROUTE_OUTLET_TO_OUTLET = "SAME_ROUTE_OUTLET_TO_OUTLET",
  DIFFERENT_ROUTE_OUTLET_TO_OUTLET = "DIFFERENT_ROUTE_OUTLET_TO_OUTLET",
  UNSUPPORTED = "UNSUPPORTED",
}

export interface SelectedScheduleSnapshot {
  supplierId: string;
  supplierName: string;
  routeId: string;
  slotId: string;
  /** HH:mm, e.g. "14:00" */
  cutoffIn: string;
  /** HH:mm, e.g. "13:30" */
  cutoffOut: string;
  /** Calendar days after cutoffOut day when cutoffIn applies. 0 = same day. */
  cutoffInDayOffset: number;
  /** Calendar day (YYYY-MM-DD, delivery timezone) this leg dispatches on. */
  dispatchDate: string;
}

export interface CptAudit {
  predictedMaterialReadyAt: string;
  /** Customer Response Time: estimate expiration window in minutes. */
  crtMinutes: number;
  /** Total Supplier Response Time in minutes. */
  srtMinutes: number;
  qrtMinutes: number;
  srtFormula: string;
  garaazDeliveryTime: number;
  /** Destination supplier prep minutes after material reaches associate branch. */
  destinationSupplierReadyTime?: number;
  movementKind: MovementKind | string;
  selectedSchedules: SelectedScheduleSnapshot[];
}
